import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { addToEndOfChain, addToStartOfChain, ApiHandlerDiscreteParameter, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter, Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain    
} from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { trackPurchaseForIterable, updateCartForIterable } from "@NA/Services/ADIAbandonedCartV2Service";
import { addCartModifiedToLocalStorage, getIfCartIsModifiied, removeCartModifiedFromLocalStorage } from "@NA/Utils/Utility";

type HandlerType = ApiHandlerDiscreteParameter<
    { order?: CartModel } & HasOnSuccess & HasOnError<string>,
    AddCartLinesApiParameter,
    CartModel,
    { updateCartApiParameter: UpdateCartApiParameter }
>;

export const CallPurchaseCompleteIterableApi: HandlerType = props => {
    const isIterableEnabled = (props.getState().context.settings as any).settingsCollection?.adiIterableSettingSettings?.isIterableEnabled;
    if(isIterableEnabled){
        trackPurchaseForIterable(props.apiResult);
        removeCartModifiedFromLocalStorage();
    }    
};

addToEndOfChain(chain, CallPurchaseCompleteIterableApi);

